import React from 'react';
import { Box } from '@mui/material';

const TabPanel = (props) => {
	const { children, value, index, boxStyles = {}, ...other } = props;

	return (
		<Box role="tabpanel" hidden={value !== index} {...other}>
			{value === index && (
				<Box paddingX={2} paddingY={1} sx={{ ...boxStyles }}>
					{children}
				</Box>
			)}
		</Box>
	);
};

export default TabPanel;
